"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.view = void 0;
var mapping_1 = require("../../mapping");
var csod = require("player-core");
var seekRedirectInProgress = false;
var SEEK_PROVIDER_ID = '18e5738f-f8d4-460b-b339-cb9a742acbf3';
function view() {
    var _this = this;
    var getStateByProps = function (props) {
        var state = {
            applyWithButtonLabel: props.applyWithButtonLabel,
            applyWithServices: []
        };
        var applyWithServices = [];
        props.services.forEach(function (service, index) {
            var providerId = service.providerId.toLowerCase();
            switch (providerId) {
                case '3d8e652c-9e82-4f76-9dde-6b90dafd2086':
                case '18e5738f-f8d4-460b-b339-cb9a742acbf3':
                    var serviceData = {};
                    serviceData["tag"] = "apply_with_" + service.name.toLowerCase();
                    serviceData["buttonText"] = state.applyWithButtonLabel.replace('{0}', service.name);
                    serviceData["warningMessageVisible"] = false;
                    serviceData["warningMessage"] = '';
                    serviceData["warningColor"] = '';
                    serviceData["warningTag"] = "apply_with_" + service.name.toLowerCase() + "_warning";
                    switch (service.name.toLowerCase()) {
                        case "linkedin":
                            serviceData["color"] = "LinkedIn";
                            serviceData["iconName"] = "LinkedIn";
                            break;
                        case "seek":
                            serviceData["color"] = "Seek hide-apply-with-seek";
                            serviceData["iconName"] = "";
                            serviceData["buttonText"] = "";
                            serviceData["warningColor"] = "full-hv-warning50 hide-apply-with-seek";
                            serviceData["warningMessageVisible"] = true;
                            serviceData["warningMessage"] = csod.viewModel.applyWithSeekWarningMessage;
                            break;
                        default:
                            break;
                    }
                    service.extras = serviceData;
                    applyWithServices.push(service);
                    break;
                case '4792074a-eb93-4c52-bc56-0afb057fccc5':
                    state['awliEnabled'] = true;
                    state['awliApiKey'] = service.credentials.apiKey;
                    state['awliIntegrationContext'] = service.credentials.integrationContext;
                    csod.viewModel.applyWithLinkedInData.isEnabled = true;
                    csod.viewModel.applyWithLinkedInData.apiKey = service.credentials.apiKey;
                    csod.viewModel.applyWithLinkedInData.integrationContext = service.credentials.integrationContext;
                    break;
            }
        });
        state.applyWithServices = applyWithServices;
        return state;
    };
    return {
        state: getStateByProps(this.props),
        initialize: function () { return Promise.resolve(); },
        mounted: function () { return __awaiter(_this, void 0, void 0, function () {
            var shouldRedirect;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        shouldRedirect = false;
                        if (!!seekRedirectInProgress) return [3, 2];
                        return [4, this.view.helpers.redirectToSeekFlow()];
                    case 1:
                        shouldRedirect = _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!shouldRedirect) {
                            this.view.helpers.updateToSeekButton();
                        }
                        return [2];
                }
            });
        }); },
        receivedProps: function (nextProps) {
            var applyWithServices = getStateByProps(nextProps).applyWithServices;
            _this.view.state.applyWithServices = applyWithServices;
            return Promise.resolve();
        },
        events: {
            onClick: this.props.onClick
        },
        helpers: {
            redirectToSeekFlow: function () { return __awaiter(_this, void 0, void 0, function () {
                var services, hasSeekProvider, url, params, seekPrefillId, seekToken, isSeekProcessed, careerSiteId, jobReqId, params_arr, i, param, redirectUrl, encodedRedirectUrl, data, error_1;
                var _a, _b, _c, _d;
                return __generator(this, function (_e) {
                    switch (_e.label) {
                        case 0:
                            _e.trys.push([0, 3, , 4]);
                            services = Array.isArray(this.props.services)
                                ? this.props.services
                                : [];
                            hasSeekProvider = services.some(function (s) { var _a; return ((_a = s === null || s === void 0 ? void 0 : s.providerId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === SEEK_PROVIDER_ID; });
                            url = new URL(window.location.href);
                            params = url.searchParams;
                            seekPrefillId = (_a = params.get('seek-prefill-id')) !== null && _a !== void 0 ? _a : '';
                            seekToken = (_b = params.get('seek-token')) !== null && _b !== void 0 ? _b : '';
                            if (!hasSeekProvider) {
                                return [2, true];
                            }
                            isSeekProcessed = sessionStorage.getItem("isSeekProcessed_" + decodeURIComponent(seekPrefillId));
                            if (isSeekProcessed === "true") {
                                return [2, false];
                            }
                            careerSiteId = (_c = csod === null || csod === void 0 ? void 0 : csod.viewModel) === null || _c === void 0 ? void 0 : _c.careerSiteId;
                            jobReqId = (_d = csod === null || csod === void 0 ? void 0 : csod.viewModel) === null || _d === void 0 ? void 0 : _d.reqId;
                            params_arr = window.location.search.slice(1).split("&");
                            for (i = params_arr.length - 1; i >= 0; i -= 1) {
                                param = params_arr[i].split("=")[0];
                                if (param === "d" || param === "provider" || param === "socialId") {
                                    params_arr.splice(i, 1);
                                }
                            }
                            redirectUrl = "" + window.location.origin + window.location.pathname;
                            if (params_arr.length > 0 && params_arr[0]) {
                                redirectUrl += "?" + params_arr.join("&");
                            }
                            encodedRedirectUrl = encodeURIComponent(redirectUrl);
                            if (!(seekPrefillId != null && seekToken != null && seekPrefillId.trim().length > 0 && seekToken.trim().length > 0 && isSeekProcessed !== "true")) return [3, 2];
                            seekRedirectInProgress = true;
                            sessionStorage.setItem("isSeekProcessed_" + decodeURIComponent(seekPrefillId), "true");
                            return [4, mapping_1.getApplyWithAuthUrl(SEEK_PROVIDER_ID, encodedRedirectUrl, careerSiteId, jobReqId, seekPrefillId, seekToken)];
                        case 1:
                            data = _e.sent();
                            if ((data === null || data === void 0 ? void 0 : data.authURL) != null && data.authURL.length > 0) {
                                window.location.replace(data.authURL);
                                return [2, true];
                            }
                            csod.logger.error("Error occurred while fetching getApplyWithAuthUrl, Please check the with admin");
                            return [2, false];
                        case 2: return [2, false];
                        case 3:
                            error_1 = _e.sent();
                            csod.logger.error("Error occurred while processing Seek redirect: " + error_1);
                            return [2, false];
                        case 4: return [2];
                    }
                });
            }); },
            updateToSeekButton: function () {
                var _a, _b, _c, _d;
                var url = new URL(window.location.href);
                var params = url.searchParams;
                var seekPrefillId = (_a = params.get('seek-prefill-id')) !== null && _a !== void 0 ? _a : '';
                var seekToken = (_b = params.get('seek-token')) !== null && _b !== void 0 ? _b : '';
                var services = Array.isArray(_this.props.services)
                    ? _this.props.services
                    : [];
                var hasSeekProvider = services.some(function (s) { var _a; return ((_a = s === null || s === void 0 ? void 0 : s.providerId) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === SEEK_PROVIDER_ID; });
                if (!hasSeekProvider)
                    return;
                var careerSiteId = (_c = csod === null || csod === void 0 ? void 0 : csod.viewModel) === null || _c === void 0 ? void 0 : _c.careerSiteId;
                var jobReqId = (_d = csod === null || csod === void 0 ? void 0 : csod.viewModel) === null || _d === void 0 ? void 0 : _d.reqId;
                var params_arr = window.location.search.slice(1).split("&");
                for (var i = params_arr.length - 1; i >= 0; i -= 1) {
                    var param = params_arr[i].split("=")[0];
                    if (param === "d" || param === "provider" || param === "socialId") {
                        params_arr.splice(i, 1);
                    }
                }
                var redirectUrl = "" + window.location.origin + window.location.pathname;
                if (params_arr.length > 0 && params_arr[0]) {
                    redirectUrl += "?" + params_arr.join("&");
                }
                var encodedRedirectUrl = encodeURIComponent(redirectUrl);
                mapping_1.getSeekDisplayButton(SEEK_PROVIDER_ID, encodedRedirectUrl, careerSiteId, jobReqId, seekPrefillId, seekToken)
                    .then(function (data) {
                    if (!data || !data.imageLink || !data.isSeekNewVersion || !data.buttonLabel) {
                        csod.logger.error("Received incomplete or invalid data from getSeekDisplayButton: Data - " + data + " ButtonLabel - " + (data === null || data === void 0 ? void 0 : data.buttonLabel) + " ImageUrl - " + (data === null || data === void 0 ? void 0 : data.imageLink) + " isSeekNewVersion - " + (data === null || data === void 0 ? void 0 : data.isSeekNewVersion) + " ");
                        console.log('Received incomplete or invalid data from getSeekDisplayButton');
                        return;
                    }
                    requestAnimationFrame(function () {
                        var _a;
                        var button = document.querySelector('button[data-tag="apply_with_seek"]');
                        var seekWarningMessage = document.querySelector('span[data-tag="apply_with_seek_warning"]');
                        var bgImageUrl = data.imageLink;
                        var isSeekNewVersion = (_a = data.isSeekNewVersion) !== null && _a !== void 0 ? _a : false;
                        var buttonLabel = data.buttonLabel;
                        if (isSeekNewVersion && button) {
                            if (bgImageUrl) {
                                var styleValue = ("\n                                background-image: url('" + bgImageUrl + "');\n                                background-position: center;\n                                background-size: contain;\n                                background-repeat: no-repeat;\n                                ").replace(/\n/g, ' ').trim();
                                button.innerHTML = "";
                                button.setAttribute('style', styleValue);
                                button.setAttribute('title', buttonLabel);
                            }
                            else {
                                button.innerHTML = buttonLabel;
                            }
                        }
                        if (button) {
                            button.classList.remove("hide-apply-with-seek");
                        }
                        if (seekWarningMessage) {
                            seekWarningMessage.classList.remove("hide-apply-with-seek");
                        }
                    });
                })
                    .catch(function (error) {
                    csod.logger.error("Error while fetching getSeekDisplayButton " + error);
                });
            }
        }
    };
}
exports.view = view;



//////////////////
// WEBPACK FOOTER
// C:/WS/ls/build/player-application-workflow/src/.tmp/ApplyWithButtons/View.js
// module id = 586
// module chunks = 0